// import store from '@/store'
const daysWithoutCache = process.env.VUE_APP_DAYS_WITHOUT_CACHE

export function handleCache(_url) {
  let patterns = []
  let match = false
  let cacheMode = 'nocache'
  let cacheTimeMode = 'day'
  let cacheString = new Date().toISOString().replace(/[^0-9]/g, '')
  //Fixed URLs
  patterns.push('agents/json/formations')
  patterns.push('agents/json/list')
  patterns.push('agents/json/view')

  if (_url.startsWith('//')) {
    _url = window.location.protocol + _url
  } else if (_url.startsWith('/')) {
    _url = window.location.origin + _url
  }

  for (var i = 0; i < patterns.length; i++) {
    match = _url.match(new RegExp(patterns[i], 'gi'))
    if (match) {
      break
    }
  }
  try {
    _url = new URL(_url)

    //dinamic URLs
    if (_url.href.indexOf('/api/v1/janoowp/bookings')) {
      var cacheLimit_date = new Date()
      cacheLimit_date.setDate(cacheLimit_date.getDate() - daysWithoutCache)
      var start = new Date(_url.searchParams.get('start_date') + ' 12:00:00')
      var end = new Date(_url.searchParams.get('end_date') + ' 12:00:00')
      if (
        _url.searchParams.get('start_date') ===
        new Date().toISOString().substring(0, 10)
      ) {
        match = true
      } else if (start > cacheLimit_date || end > cacheLimit_date) {
        match = true
        //cacheMode = 'tmpcache'
        cacheTimeMode = 'hour'
      }
    }

    switch (cacheTimeMode) {
    case 'day':
      cacheString = cacheString.substring(0, 8)
      break
    case 'hour':
      cacheString = cacheString.substring(0, 10)
      break
    case '10_minutes':
      cacheString = cacheString.substring(0, 11)
      break
    case '1_minute':
      cacheString = cacheString.substring(0, 12)
      break

    default:
      break
    }

    if (match) {
      // _url.searchParams.set(cacheMode, cacheString)

      // if (process.env.NODE_ENV != "production") {
      //     console.log('TMP CACHED: ', _url.href)
      // }
    } else {
      // if (process.env.NODE_ENV != "production") {
      //     console.log('CACHED  URL: ', _url.href)
      // }
    }

    return _url.href
  } catch (error) {
    console.error('handleCache(_url)', _url, error)
    return _url
  }
}
